export default __webpack_public_path__ + "55a92a423f155fde91c6a7e53ba5c835.png";